export default {
    error_country_home: 'a1.x211',
    error_error_code: 'a1.x212',
}